module.exports = __webpack_public_path__ + "static/hero_desktop-c4c419721b123d3955530d83e83de661.svg";